var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
		linkTag.crossOrigin = "anonymous";
	}
	(function(linkTag) {
	                if (typeof _N_E_STYLE_LOAD === 'function') {
	                    const { href, onload, onerror } = linkTag;
	                    _N_E_STYLE_LOAD(href.indexOf(window.location.origin) === 0 ? new URL(href).pathname : href).then(()=>onload == null ? void 0 : onload.call(linkTag, {
	                            type: 'load'
	                        }), ()=>onerror == null ? void 0 : onerror.call(linkTag, {}));
	                } else {
	                    document.head.appendChild(linkTag);
	                }
	            })(linkTag)
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	78068: 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"1526":1,"2528":1,"3826":1,"3855":1,"5535":1,"6589":1,"6993":1,"7217":1,"8124":1,"8749":1,"9678":1,"9716":1,"10161":1,"11076":1,"11413":1,"11520":1,"11695":1,"18291":1,"18512":1,"20260":1,"20446":1,"21168":1,"21300":1,"21775":1,"23375":1,"23654":1,"24469":1,"27984":1,"28078":1,"28683":1,"32593":1,"32845":1,"33304":1,"33345":1,"33362":1,"33379":1,"34533":1,"34584":1,"36313":1,"36780":1,"37339":1,"38744":1,"40885":1,"42611":1,"45194":1,"46032":1,"46220":1,"46952":1,"48538":1,"49153":1,"50360":1,"51077":1,"51496":1,"51984":1,"52203":1,"53854":1,"55448":1,"55991":1,"58716":1,"59218":1,"61965":1,"62110":1,"63183":1,"63676":1,"63948":1,"64881":1,"65757":1,"65957":1,"66809":1,"66892":1,"67189":1,"67388":1,"68641":1,"70941":1,"71857":1,"72090":1,"72678":1,"72884":1,"73031":1,"73731":1,"74277":1,"74372":1,"75449":1,"76528":1,"77966":1,"79097":1,"79742":1,"79764":1,"80093":1,"80770":1,"81798":1,"85455":1,"85564":1,"86670":1,"87069":1,"87127":1,"90030":1,"90551":1,"90590":1,"91397":1,"91426":1,"91516":1,"92204":1,"92430":1,"92536":1,"92647":1,"93630":1,"95789":1,"95856":1,"96364":1,"98374":1,"99388":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr